import { find, isNil, propEq } from 'ramda'
import { countries } from '../constants'

export function getCountryName(id: string) {
  let country = find(propEq('id', id), countries)
  return isNil(country) ? null : country.name
}
